// extracted by mini-css-extract-plugin
export default {"currentStep":"StepFrame_currentStep__fXGBt","errorSection":"StepFrame_errorSection__Pg2Vw"};